import { Component } from '@angular/core';

import { SharedModule } from 'src/shared.module';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'footer',
    templateUrl: './footer.html',
    standalone: true,
    imports: [SharedModule, CommonModule]
})
export class FooterComponent {
    currYear: number = new Date().getFullYear();
    constructor() {}
    ngOnInit() {}
}
